import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex",
  style: {"min-height":"45vw"}
}
const _hoisted_2 = { class: "content p-4 w-100" }
const _hoisted_3 = { class: "d-flex justify-content-between mb-8" }
const _hoisted_4 = { class: "card-title mt-0" }

import AllowAccessOfficeAccountList from "@/components/AllowAccessOfficeParts/AllowAccessOfficeAccountList.vue"
import AllowAccessOfficeSearchForm from "@/components/AllowAccessOfficeParts/AllowAccessOfficeSearchForm.vue"
import AllowAccessOfficeModal from "@/components/AllowAccessOfficeParts/AllowAccessOfficeModal.vue"
import PaginateWithCount from "@/components/PaginateWithCount.vue"
import getPaginatedAccountResponse from "@/types/responses/getPaginatedAccounts"
import getOperationOfficeResponse from "@/types/responses/getOperationOffice"
import { Ref, ref, reactive, onMounted, watch } from 'vue'
import Api from "@/services/api/ApiServiceFabrick"
import { useAuth } from "@/services/user/Auth0UserProvider"
import i18n from '@/lang/i18n';
import { MANAGEMENT_OFFICE_TYPE } from "@/services/consts"

type searchParamsType = {
  page: number,
  withs: string,
  status: string,
  sort: string | null,
  sort_type: string | null,
  officeable_type: string | null,
  type_class: string | null,
  officeable_id: number | null,
  account_name: string | null
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AllowAccessOfficeList',
  props: {
    showFlash: { type: Function }
  },
  setup(__props: any) {

const props = __props

document.title = i18n.global.t('pages.allowAccessOffice.title.list')
const selfRoleId = ref(2)
const currentPage = ref(1)
const totalPage = ref(0)
const itemsPerPage = ref(50)
const allElementsCount = ref(0)
const accounts: Ref<getPaginatedAccountResponse[]> = ref([])
const operationOffices: Ref<getOperationOfficeResponse[]> = ref([])
const filteredOperationOffices: Ref<getOperationOfficeResponse[]> = ref([])
const isLoading = ref(false)
const isSearchCompleted = ref(false)
const searchParams: searchParamsType = reactive({
  page: 1,
  withs: 'updatedBy',
  status: 'only-active',
  sort: null,
  sort_type: null,
  officeable_type: null,
  type_class: null,
  officeable_id: null,
  account_name: null
})
const selectedAccount = ref([])
const modalState: Ref<boolean> = ref(false)
const isManagementOffice: Ref<boolean> = ref(false)
const { loginWithRedirect } = useAuth()

onMounted(() => {
  isLoading.value = true
  Api().getSelfAccount().then((data) => {
    selfRoleId.value = data.role_id
    if (data.login_organization_type == MANAGEMENT_OFFICE_TYPE) {
      isManagementOffice.value = true
    }
    if (!isManagementOffice.value) {
      getAccounts()
    } else {
      isLoading.value = false
    }
    getOperationOffices()
  }).catch((error) => {
    const res = error.response
    if (res.status == 401) loginWithRedirect({ appState: { targetUrl: location.pathname } });
    isLoading.value = false
  })
})

function getAccounts() {
  isLoading.value = true
  Api().getPaginatedAccounts(searchParams).then((data: getPaginatedAccountResponse) => {
    accounts.value = filterOperationOfficeAccounts(data.accounts)
    currentPage.value = data.current_page
    totalPage.value = data.total_page
    allElementsCount.value = data.total
    itemsPerPage.value = data.per_page
    isLoading.value = false
    isSearchCompleted.value = true
  }).catch((error) => {
    const res = error.response
    switch (res.status) {
      case 401:
        loginWithRedirect({ appState: { targetUrl: location.pathname } })
        break
      case 403:
        location.reload()
        break
      case 422:
        props.showFlash(i18n.global.t('pages.allowAccessOffice.errors.getAccount'), "error", false)
    }
    isLoading.value = false
  })
}

function filterOperationOfficeAccounts(accounts: any) {
  return accounts.filter((account: any) => {
    return account.officeable_type == 'App\\Models\\OperationOffice'
  })
}

function getOperationOffices () {
  Api().autoCompleteOperationOffices().then((data: getOperationOfficeResponse[]) => {
    operationOffices.value = data
  }).catch((error) => {
    const res = error.response
    switch (res.status) {
      case 401:
        loginWithRedirect({ appState: { targetUrl: location.pathname } })
        break
      case 403:
        location.reload()
        break
      case 422:
        props.showFlash(i18n.global.t('pages.allowAccessOffice.errors.getOperationOffice'), "error", false)
    }
    isLoading.value = false
  })
}

function getAccountsAfterSetParams(params: searchParamsType) {
  searchParams.page = 1
  searchParams.officeable_type = params.officeable_type
  searchParams.type_class = params.type_class
  searchParams.officeable_id = params.officeable_id
  searchParams.account_name = params.account_name
  searchParams.status = params.status
  getAccounts()
}

function changeSortOrder(sortItem: any, sortType: any) {
  searchParams.sort = sortItem
  searchParams.sort_type = sortType
  if (currentPage.value == 1) {
    getAccounts()
  } else {
    currentPage.value = 1
  }
}

function openModal(account: any) {
  selectedAccount.value = account
  if (account) {
    modalState.value = true
    filteredOperationOffices.value = excludingBelongOffice(account)
  }
}

function excludingBelongOffice(account: any) {
  return operationOffices.value.filter((operationOffice) => {
    return operationOffice.id != account.officeable_id
  })
}

function inactivateDialog(bool: boolean) {
  modalState.value = bool
}

watch(currentPage, () => {
  searchParams.page = currentPage.value
  getAccounts()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", _hoisted_4, _toDisplayString(_unref(i18n).global.t('pages.allowAccessOffice.title.list')), 1)
      ]),
      _createElementVNode("div", null, [
        _createVNode(AllowAccessOfficeAccountList, {
          class: "mb-2",
          selfRoleId: selfRoleId.value,
          accounts: accounts.value,
          isLoading: isLoading.value,
          isManagementOffice: isManagementOffice.value,
          isSearchCompleted: isSearchCompleted.value,
          onChangeSortOrder: changeSortOrder,
          onOpenModal: openModal
        }, null, 8, ["selfRoleId", "accounts", "isLoading", "isManagementOffice", "isSearchCompleted"]),
        _createVNode(PaginateWithCount, {
          class: "justify-end",
          totalPage: totalPage.value,
          modelValue: currentPage.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
          itemsPerPage: itemsPerPage.value,
          allElementsCount: allElementsCount.value,
          showItemCount: true
        }, null, 8, ["totalPage", "modelValue", "itemsPerPage", "allElementsCount"]),
        _cache[1] || (_cache[1] = _createElementVNode("hr", null, null, -1)),
        _createVNode(AllowAccessOfficeModal, {
          selectedAccount: selectedAccount.value,
          operationOffices: filteredOperationOffices.value,
          modalState: modalState.value,
          showFlash: props.showFlash,
          onCloseModal: inactivateDialog
        }, null, 8, ["selectedAccount", "operationOffices", "modalState", "showFlash"])
      ])
    ]),
    _createVNode(AllowAccessOfficeSearchForm, {
      loading: isLoading.value,
      onSearch: getAccountsAfterSetParams
    }, null, 8, ["loading"])
  ]))
}
}

})